import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { goTo } from '@adornis/router/client/open-href.js';
import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-image.js';
import '@chancenwerk/design/components/fonts.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import g_logo from '../assets/logo_chancencampus.svg';
import { CampusRoutes } from './../routes.js';

/**
 * @customElement campus-page-no-permission
 */
@customElement('campus-page-no-permission')
export class CampusPageNoPermission extends ChemistryLitElement {
  @state() private readonly _size = new WindowSizeController(this);

  override render() {
    return html`
      <cr-flex padding="${this._size.mobile ? 'md' : 'xxl'}" space="lg" center crossaxis-center>
        <cr-image ${css({ width: '80%', maxWidth: '30rem' })} is-url .value="${g_logo}" mode="width"></cr-image>
        <cr-h3> Wie bist du denn hier gelandet? </cr-h3>
        <cr-text> Du besitzt nicht die benötigten Rechte diese Seite aufzurufen. </cr-text>
        <cr-button mode="action" icon="chevron_left" @click=${() => goTo(CampusRoutes.dashboard)}>
          Zurück zu deinem Bereich
        </cr-button>
      </cr-flex>
    `;
  }
}
